import { EventData, FlattenedEventData } from '@/types/features/settings/notification-methods.types';
import { notificationApi } from '@/store/api/notificationApi';

export function flattenDeliveryMethods(data: EventData): FlattenedEventData {
  const flat: FlattenedEventData = {
    user_id: data.user_id,
    event_type: data.event_type,
    event_ui_name: data.event_ui_name,
  };

  for (const method of data.delivery_methods) {
    flat[method.name.toLowerCase()] = method.enabled;
  }

  return flat;
}

export function restoreDeliveryMethods(data: FlattenedEventData): EventData {
  const { email, dashboard, sms, user_id, event_type, event_ui_name } = data;

  return {
    user_id,
    event_type,
    event_ui_name,
    delivery_methods: [
      { name: 'Email', enabled: !!email },
      { name: 'Dashboard', enabled: !!dashboard },
      { name: 'SMS', enabled: !!sms },
    ],
  };
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const updateNotificationMethodsCache = (newData: any, userId: any) => {
  return notificationApi.util.updateQueryData('getNotificationsDM', { uids: userId }, (draft) => {
    Object.assign(draft, newData);
  });
};
